import {
  BaggingDisputeSummaryRequestInterface,
  BaggingToReadyToCargoRequestInterface,
  ChangeBaggingRequestInterface,
  UpdateBaggingInterface
} from "@/data/payload/contracts/BaggingRequest";
import { BaggingMapper } from "@/data/persistences/mappers/BaggingMapper";
import { BaggingRepositoryInterface } from "@/data/persistences/repositories/contracts/BaggingRepositoryInterface";
import {
  BaggingDataDetail,
  BaggingDisputeSummary,
  BaggingEntities,
  BaggingSttList,
  RegionBaggingGrouping
} from "@/domain/entities/Bagging";
import { ResponsePayload, ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import { Endpoints } from "../../misc/Endpoints";
import ApiService from "../../services/ApiService";
import {
  BaggingDisputeSummaryRequest,
  BaggingListRequest,
  BaggingToReadyToCargoRequest,
  CreateApiRequest,
  UpdateBaggingRequest
} from "@/data/payload/api/BaggingApiRequest";
import { downloadFile } from "../../misc/Utils";

export class BaggingApiRepository implements BaggingRepositoryInterface {
  private service: ApiService;
  private mapper: BaggingMapper;
  private endpoints: Endpoints;

  constructor(
    service: ApiService,
    mapper: BaggingMapper,
    endpoints: Endpoints
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }
  
  public async updateBaggingToReadyToCargo(payload: BaggingToReadyToCargoRequestInterface): Promise<ResponsePayloadV2> {
    const resp = await this.service.invoke(
      "post",
      this.endpoints.updateBaggingToRTC(),
      undefined,
      payload as BaggingToReadyToCargoRequest
    );
    return this.mapper.convertUpdateBaggingRTCFromApi(resp);
  }

  public async getListBagging(
    params: BaggingListRequest
  ): Promise<BaggingEntities> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getListBagging(params),
      {}
    );
    return this.mapper.convertBaggingDataFromApi(resp);
  }

  public async getDetailBagging(id: number): Promise<BaggingDataDetail> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getDetailBagging(id),
      {}
    );
    return this.mapper.convertBaggingDetailFromApi(resp);
  }

  public async getDetailSttNumber(
    sttNumber: string,
    partnerId?: number
  ): Promise<BaggingSttList> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getDetailSttNumberBagging(sttNumber, partnerId),
      {}
    );
    return this.mapper.convertSttNumberBaggingDetailFromApi(resp);
  }

  public async createBagging(
    payload: ChangeBaggingRequestInterface
  ): Promise<ResponsePayload> {
    const resp = await this.service.invoke(
      "post",
      this.endpoints.createBagging(),
      undefined,
      payload as CreateApiRequest
    );
    return this.mapper.convertChangeDataFromApi(resp);
  }

  public async updateBagging(
    payload: UpdateBaggingInterface
  ): Promise<ResponsePayload> {
    const response = await this.service.invoke(
      "put",
      this.endpoints.updateBagging(),
      {},
      payload as UpdateBaggingRequest
    );
    return this.mapper.convertChangeDataFromApi(response);
  }

  public async downloadBagging(data: any): Promise<any> {
    return downloadFile(
      `${Endpoints.baseUrl}${this.endpoints.downloadManifest(
        `bag/xlsx?bag_id=${data.id}`
      )}`,
      `Manifest Bag - ${data.bagCode}`,
      ".xlsx",
      true
    );
  }

  public async getRegionBaggingGrouping(
    code: string
  ): Promise<RegionBaggingGrouping> {
    const response = await this.service.invoke(
      "get",
      this.endpoints.getRegionBaggingGrouping(code),
      {}
    );
    return this.mapper.convertRegionBaggingGroupingData(response);
  }

  public async getBaggingDisputeSummary(
    params: BaggingDisputeSummaryRequest
  ): Promise<BaggingDisputeSummary> {
    const response = await this.service.invoke(
      "get",
      this.endpoints.getBaggingDisputeSummary(params),
      {}
    );
    return this.mapper.convertBaggingDisputeSummaryFromApi(response);
  }

  public async downloadBaggingDisputeSummary(
    payload: any
  ): Promise<any> {
    return downloadFile(
      `${Endpoints.baseUrl}${this.endpoints.downloadBaggingDisputeSummary()}`,
      `BAGGING_DISPUTE_${payload.startDate}_${payload.endDate}`,
      ".xlsx",
      true,
      60000,
      "POST",
      this.mapper.convertBaggingDisputeSummaryDownloadPayload(payload),
      true
    );
  }
}

